import React, { forwardRef } from 'react';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import dayjs from 'dayjs';

import { Anchor, EmploymentStatus } from '../../components';
import { FooterComponentDataType } from '../../types';
import {
  Content,
  ContentText,
  EmailLink,
  Navigation,
  NavigationLeftColumn,
  NavigationRightColumn,
  Root,
} from './Footer.styles';

type Props = {
  data?: FooterComponentDataType;
};

export const Footer = forwardRef<HTMLDivElement, Props>(({ data }, ref) => {
  const {
    emailAddress,
    emailCallToAction,
    emailSubjectLine,
    headline,
    isOpenToWork,
    links,
  } = data || {};
  return (
    <Root>
      <Anchor ref={ref} verticalOffset={500} />
      <Container>
        <Content>
          <ContentText>
            <h4>{headline}</h4>
            {isOpenToWork && <EmploymentStatus size="large" />}
          </ContentText>
          <EmailLink
            href={`mailto:${emailAddress}?subject=${emailSubjectLine}`}>
            {emailCallToAction}
          </EmailLink>
        </Content>
      </Container>
      <Navigation>
        <NavigationLeftColumn>
          {links
            ?.sort((a, b) => a.order - b.order)
            ?.map((data) => (
              <Button
                key={data.order}
                href={data.href}
                target="_"
                variant="text">
                {data.title}
              </Button>
            ))}
        </NavigationLeftColumn>
        <NavigationRightColumn>
          <span>&#169; {dayjs().year()}</span>
        </NavigationRightColumn>
      </Navigation>
    </Root>
  );
});

Footer.displayName = 'Footer';
